import { APP_TYPE } from '@zonofi/zono-money-store';
import { DrawerItems } from '../../types';
import { FIELD_OPS_ROUTES, SELLER_WEBAPP_ROUTES } from '../../constants';

const normalizeRoute = (route: string) => route.split('?')[0];

export const getDrawerConfigValue = (rawConfigValue: unknown) => {
  if (
    typeof rawConfigValue === 'object' &&
    rawConfigValue !== null &&
    'value' in rawConfigValue
  ) {
    return (rawConfigValue as { value?: unknown }).value;
  }

  return rawConfigValue;
};

export const isDrawerItemVisible = (rawConfigValue: unknown) => {
  const configValue = getDrawerConfigValue(rawConfigValue);
  return !(configValue === false || configValue === 'false');
};

export const getDefaultPathFromDrawerConfig = (
  drawerItem: DrawerItems[],
  drawerConfig: Record<string, unknown>,
  appType: APP_TYPE
) => {
  for (const item of drawerItem) {
    if (item.id && !isDrawerItemVisible(drawerConfig[item.id])) continue;

    if (item.route) return item.route;

    const firstVisibleChildRoute = item.children?.find(
      (child) =>
        child.route &&
        (!child.id || isDrawerItemVisible(drawerConfig[child.id]))
    )?.route;

    if (firstVisibleChildRoute) return firstVisibleChildRoute;
  }

  return appType === APP_TYPE.FIELDS_OPS
    ? FIELD_OPS_ROUTES.CUSTOMER_LIST
    : SELLER_WEBAPP_ROUTES.CONVERSATION_LIST;
};

export const isRefUrlAllowedByDrawer = (
  refUrl: string,
  drawerConfig: Record<string, unknown>,
  drawerItem: DrawerItems[]
) => {
  const normalizedRefUrl = normalizeRoute(refUrl);

  for (const item of drawerItem) {
    if (item.route && normalizeRoute(item.route) === normalizedRefUrl) {
      return !item.id || isDrawerItemVisible(drawerConfig[item.id]);
    }

    const matchedChild = item.children?.find(
      (child) => child.route && normalizeRoute(child.route) === normalizedRefUrl
    );

    if (matchedChild) {
      const parentVisible =
        !item.id || isDrawerItemVisible(drawerConfig[item.id]);
      const childVisible =
        !matchedChild.id || isDrawerItemVisible(drawerConfig[matchedChild.id]);

      return parentVisible && childVisible;
    }
  }

  return true;
};
